module.exports = __webpack_public_path__ + "img/p4-mobile.52206871.png";